import { jsxs, jsx } from "react/jsx-runtime";
import { c } from "react-compiler-runtime";
/* empty css               */
const Breadcrumb = (t0) => {
  const $ = c(8);
  const {
    navStack,
    onNavigateTo
  } = t0;
  if (navStack.length <= 1) {
    return null;
  }
  let t1;
  if ($[0] !== navStack || $[1] !== onNavigateTo) {
    let t22;
    if ($[3] !== navStack.length || $[4] !== onNavigateTo) {
      t22 = (item, index) => {
        const isLast = index === navStack.length - 1;
        const depthClass = index === 0 ? "graphiql-doc-explorer-breadcrumb-root" : isLast ? "graphiql-doc-explorer-breadcrumb-current" : "graphiql-doc-explorer-breadcrumb-intermediate";
        return /* @__PURE__ */ jsxs("span", { className: "graphiql-doc-explorer-breadcrumb-segment", children: [
          index > 0 && /* @__PURE__ */ jsx("span", { className: "graphiql-doc-explorer-breadcrumb-sep", "aria-hidden": "true", children: "›" }),
          isLast ? /* @__PURE__ */ jsx("span", { className: depthClass, children: item.name }) : /* @__PURE__ */ jsx("a", { href: "#", className: depthClass, onClick: (event) => {
            event.preventDefault();
            onNavigateTo(index);
          }, "aria-label": `Go back to ${item.name}`, children: item.name })
        ] }, index);
      };
      $[3] = navStack.length;
      $[4] = onNavigateTo;
      $[5] = t22;
    } else {
      t22 = $[5];
    }
    t1 = navStack.map(t22);
    $[0] = navStack;
    $[1] = onNavigateTo;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[6] !== t1) {
    t2 = /* @__PURE__ */ jsx("nav", { className: "graphiql-doc-explorer-breadcrumb", "aria-label": "Schema navigation path", children: t1 });
    $[6] = t1;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  return t2;
};
export {
  Breadcrumb
};
//# sourceMappingURL=breadcrumb.js.map
